const fieldMessage = el => {
  const { validity, dataset } = el;
  if (validity.valueMissing || (el.required && typeof el.value === 'string' && el.value.trim() === '')) {
    if (dataset.requiredMessage) return dataset.requiredMessage;
    return el.tagName === 'SELECT' ? 'Please choose an option' : 'This field is required';
  }
  if (validity.typeMismatch && el.type === 'email') return 'Please enter a valid email address';
  if (validity.rangeUnderflow || validity.rangeOverflow) {
    if (dataset.rangeMessage) return dataset.rangeMessage;
    return el.max ? `Please enter a number between ${el.min} and ${el.max}` : `Please enter at least ${el.min}`;
  }
  if (validity.badInput || validity.stepMismatch) return 'Please enter a whole number';
  return el.validity.valid ? null : el.validationMessage;
};

export const getFieldErrors = form => {
  const errors = {};
  let firstInvalid = null;
  Array.from(form.elements).forEach(el => {
    if (!el.name || !el.willValidate) return;
    const message = fieldMessage(el);
    if (!message) return;
    errors[el.name] = message;
    if (!firstInvalid) firstInvalid = el;
  });
  return { errors, firstInvalid };
};

export const focusInvalidField = (el, headerOffset = 220) => {
  const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  el.focus({ preventScroll: true });
};
